import { Observable } from 'rxjs/Observable';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { HttpClient } from '@angular/common/http';
import { Client } from './../../../models/client';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { PNotifyService } from '../../../services/pnotify.service';

@Component({
  selector: 'app-client-datatable',
  templateUrl: './client-datatable.component.html',
  styleUrls: ['./client-datatable.component.css']
})
export class ClientDatatableComponent implements OnInit, OnDestroy {

  filter = {
    username: '',
    name: ''
  };
  staticFilter = {
    username: '',
    name: ''
  };

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;
  pack: any;

  dtOptions: any = {};
  clients: any[];
  pnotify = undefined;

  // ─── Confirmation Dialog ────────────────────────────────────────
  showConfirmModal = false;
  confirmTitle = '';
  confirmMessage = '';
  confirmIcon = '';
  confirmBtnText = '';
  confirmBtnClass = '';
  confirmAction: () => void = null;
  confirmLoading = false;
  constructor(
    private http: HttpClient,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    // this.filterForm = new FormGroup();
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit(): void {
    this.dtOptions = {
      searching: false,
      pageLength: 5,
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/client',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.clients = resp.data;
          const dta = [];
          this.clients.forEach(client => {
            if (client.pack === '1') {this.pack = "Start";}
            else if (client.pack === '2') {this.pack = "Essentiel";}
            else if (client.pack === '3') {this.pack = "Pro";}
            else {this.pack = "-";}
            dta.push({
              id: client.id,
              checkbox: `<label class="el-switch" style="font-size:80%">
                          <input  type="checkbox"
                                  name="checkboxs[]"
                                  value="${client.id}"
                                  ${this.selectedAll ? 'checked' : ''}
                          >
                          <span class="el-switch-style"></span>
                        </label>`,
              name: client.name,
              //username: client.username,
              phone: client.phone,
              pack: this.pack,
              expiration: moment(client.expiration).format('DD/MM/YYYY'),
              SendEmailAccess: client.SendEmailAccess == 0 ? `<label style="color:green">Envoyé</label>`
              : `<label style="color:orange">En-cours</label>`,
              actions: `
                <a class="btn btnAction btnEmailAcces" data-client-id="${client.id}">
                  <i class="fa fa-envelope fa-2x" aria-hidden="true"></i>Infos d'accès par email
                </a>  
                <a class="btn btnAction btnNavigate" data-url="/client/view/${client.id}">
                  <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
                </a>
                <a class="btn btnAction btnNavigate" data-url="/client/edit/${client.id}">
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>Modifier
                </a>
                <button class="btn btnAction btnClone" data-client-id="${client.id}" data-client-name="${client.name}" style="color: #ff9800;">
                  <i class="fa fa-clone fa-2x" aria-hidden="true"></i>Cloner
                </button>
                <button class="btn btnAction btnDelete" data-client-id="${client.id}">
                  <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                </button>
              `
            });
          });
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'client_' + aData.id);
      },
      columns: [
        { data: 'checkbox' },
        { data: 'name' },
        //{ data: 'username' },
        { data: 'phone' },
        { data: 'pack' },
        { data: 'expiration' },
        { data: 'SendEmailAccess' },
        { data: 'actions' },
      ],
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnEmailAcces', (event) => {
      this.onEmailAcces($(event.currentTarget).data('clientId'));
    });
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('clientId'));
    });
    $('table').on('click', '.btnClone', (event) => {
      this.onClone($(event.currentTarget).data('clientId'), $(event.currentTarget).data('clientName'));
    });
    $('table').on('click', '.btnNavigate', (event) => {
      this.onNavigate($(event.currentTarget).data('url'));
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());
    $('table').on('draw.dt', (event) => this.onCheckChange());
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onEmailAcces(id) {
    let selectedclient;
    this.clients.forEach((client) => {
      if (id == client.id) {
        selectedclient = client;
        client.SendEmailAccess = 1; // Update directly in this.clients
        selectedclient.SendEmailAccess = 1;
      }
    });

    if (selectedclient) {
      this.http.put(
          '/api/client/' + id,
          { client: selectedclient }
        ).subscribe(result => {
          this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
          });
        });
        this.pnotify.notice({
        title: 'Information',
        text: 'La demande d\'envoie de l\'email est enregirstré',
        stack: {
          firstpos1: 70, firstpos2: 10,
          modal: true,
          overlay_close: true
        },
        hide: false,
        modules: {
          Confirm: {
            confirm: true,
            buttons: [
              {
                text: 'Ok',
                addClass: 'btn btn-chico',
                click: (notice) => {
                  notice.close();
                  notice.fire('pnotify.cancel', { notice });
                }
              }
            ]
          }
        }
      });
    } else {
      console.error('Client not found with ID:', id);
    }

  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/client/' + id)
      .subscribe(
        result => {
          document.getElementById('client_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onClone(id, name) {
    this.confirmTitle = 'Confirmation';
    this.confirmMessage = `Cloner le client "${name}" et son école en mode DEMO ?\n\nCela créera une copie avec des données anonymisées (IMEI, téléphones, mots de passe fictifs).`;
    this.confirmIcon = 'fa fa-clone';
    this.confirmBtnText = 'Confirmer';
    this.confirmBtnClass = 'btn btn-warning';
    this.confirmLoading = false;
    this.confirmAction = () => { this.cloneClient(id); };
    this.showConfirmModal = true;
  }

  executeConfirm() {
    if (this.confirmAction) { this.confirmAction(); }
  }

  cloneClient(id) {
    // Show progress
    this.confirmTitle = 'Clonage en cours';
    this.confirmMessage = 'Veuillez patienter pendant le clonage des données...';
    this.confirmIcon = 'fa fa-spinner fa-spin';
    this.confirmBtnText = '';
    this.confirmBtnClass = 'btn btn-warning';
    this.confirmLoading = true;
    this.confirmAction = null;
    this.showConfirmModal = true;

    this.http.post(`/api/admin/clients/${id}/clone`, {}).subscribe(
      (result: any) => {
        this.confirmTitle = 'Succès';
        this.confirmMessage = `Client DEMO créé !\n\nÉcole: ${result.newSchoolName}\nBus: ${result.summary.buses}\nZones: ${result.summary.zones}\nPassagers: ${result.summary.passengers}\nTrajets: ${result.summary.journeys}\nResponsables: ${result.summary.responsibles}`;
        this.confirmIcon = 'fa fa-check';
        this.confirmBtnText = 'Voir';
        this.confirmBtnClass = 'btn btn-success';
        this.confirmLoading = false;
        this.confirmAction = () => { this.zone.run(() => this.router.navigate(['/school/view', result.newSchoolId])); };
        this.showConfirmModal = true;
      },
      (error) => {
        this.confirmTitle = 'Erreur';
        this.confirmMessage = error.error ? error.error.error : 'Une erreur est survenue';
        this.confirmIcon = 'fa fa-times';
        this.confirmBtnText = 'Ok';
        this.confirmBtnClass = 'btn btn-danger';
        this.confirmLoading = false;
        this.confirmAction = () => { this.showConfirmModal = false; };
        this.showConfirmModal = true;
      }
    );
  }

  onFilter(): void {
    this.staticFilter = this.filter;
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/client/client-datatable/client-datatable.component.ts